import Vue from 'vue'
import extraFiltersComponent from './template'
Vue.component('bus-stops-extra-filters', extraFiltersComponent)
